import { Injectable } from '@angular/core';
import { AppVersion } from '@ionic-native/app-version';


@Injectable()
export class VersionProvider {

  constructor(
    private appVersion: AppVersion
  ) {}

  getVersionNumber() {
    return this.appVersion.getVersionNumber();
  }
}



// WEBPACK FOOTER //
// ./src/providers/version/version.ts